import objToArray from './objToArray';
import useIntlTranslations from './useIntlTranslations';

const useMsg = (path) => {
  const translations = useIntlTranslations(path);
  return objToArray(translations);
};

export default useMsg;
